/**
 * Утилиты для работы с Telegram WebApp
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Безопасное получение Telegram WebApp
 * Использует window объект для хранения, чтобы избежать проблем с минификатором
 * @returns {object|null} Telegram WebApp объект или null
 */
export function getTelegramWebAppSafe() {
  return window.__glitchlingsTelegramWebApp;
}

/**
 * Безопасная установка Telegram WebApp
 * Использует window объект для хранения, чтобы избежать проблем с минификатором
 * @param {object|null} app - Telegram WebApp объект или null
 */
export function setTelegramWebAppSafe(app) {
  window.__glitchlingsTelegramWebApp = app;
}

/**
 * Инициализация Telegram WebApp при загрузке
 * 
 * Сохраняет WebApp в window для безопасного доступа.
 * Должна быть вызвана при загрузке страницы.
 * 
 * @returns {void}
 */
export function initTelegramWebApp() {
  if (!window.__glitchlingsTelegramWebApp) {
    window.__glitchlingsTelegramWebApp = (window.Telegram && window.Telegram.WebApp) || null;
    console.log('[Telegram Utils] 📱 Telegram WebApp сохранён:', !!window.__glitchlingsTelegramWebApp);
  }
}

/**
 * Проверка наличия Telegram WebApp
 * 
 * Проверяет наличие и валидность Telegram WebApp объекта,
 * проверяя наличие поля platform с валидным значением.
 * 
 * @returns {boolean} true если Telegram WebApp доступен и валиден
 */
export function hasTelegramWebApp() {
  const webApp = getTelegramWebAppSafe();
  return !!(
    webApp &&
    typeof webApp.platform === "string" &&
    webApp.platform !== "" &&
    webApp.platform !== "unknown"
  );
}

/**
 * Проверка наличия Telegram в userAgent
 * 
 * Проверяет наличие строки "Telegram" в navigator.userAgent.
 * 
 * @returns {boolean} true если Telegram обнаружен в userAgent
 */
export function hasTelegramUserAgent() {
  return /Telegram/i.test(navigator.userAgent || "");
}

/**
 * Проверка, запущено ли приложение в Telegram
 * 
 * Комбинированная проверка: проверяет наличие Telegram WebApp
 * или наличие Telegram в userAgent.
 * 
 * @returns {boolean} true если приложение запущено в Telegram
 */
export function isInTelegram() {
  return hasTelegramWebApp() || hasTelegramUserAgent();
}

